/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Routes.tsx
 *
 * Project Title : RDR7000
 *
 * Description   : Routes component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : July 31, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : July 31, 2020
 * Description   : Added Routes component to define all routes of the application
 *
 *
 ******************************************************************************/

import React, { FC, lazy, Suspense, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { Loader } from '@scuf/common';
import { Authorize, useAuth } from 'components/Auth';
import { appConfig } from 'shared/utils';
import { ErrorBoundary } from '../ErrorBoundary';

const Header = lazy(() => import('components/Header'));
const Footer = lazy(() => import('components/Footer'));
const CommonHeader = lazy(() => import('components/CommonHeader'));
const Home = lazy(() => import('pages/Home'));
const NewConfiguration = lazy(() => import('pages/NewConfiguration'));

const Logout: FC = () => {
  useEffect(() => {
    window.location.href = appConfig.asds_endpoint;
    // tslint:disable-next-line: align
  }, []);

  return <h1>Logging Out..</h1>;
};

export const Routes: FC = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  let routes;

  if (isAuthenticated) {
    // document.dispatchEvent(new CustomEvent("loadCookieBanner"));
    // alert("loadCookieBanner")
    routes = (
      <Suspense
        fallback={
          <Loader>
            <div className="placeholder" />
          </Loader>
        }
      >
        <Header />
        <CommonHeader>
          <ErrorBoundary key={location.pathname}>
            <Suspense
              fallback={
                <Loader>
                  <div className="placeholder" />
                </Loader>
              }
            >
              <Switch>
                <Route path="/" exact={true}>
                  <Home />
                </Route>
                <Route path="/new" exact={true}>
                  <NewConfiguration />
                </Route>
                <Redirect from="/authorize" to="/" />
                <Route render={() => <h1>Four Oh Four!!</h1>} />
              </Switch>
            </Suspense>
          </ErrorBoundary>
        </CommonHeader>
        <Footer />
      </Suspense>
    );
  } else {
    routes = (
      <Switch>
        <Route path="/logout">
          <Logout />
        </Route>
        <Route path="/authorize">
          <Authorize />
        </Route>
        <Redirect to="/authorize" />
      </Switch>
    );
  }

  return <main>{routes}</main>;
};
